import { Environment as MatomoEnvironment } from '@bbnpm/bb-analytics';
import { Environments as EcEnvironments } from '@ec/common';

export interface MatomoConfiguration {
  siteId: number;
  environment: MatomoEnvironment;
  internal: boolean;
  namespaceDefinition?: any
}

export const MATOMO_CONFIG: { [ key: string ]: MatomoConfiguration } = {
  [ EcEnvironments.LOCAL.name ]: {
    siteId: 22,
    environment: MatomoEnvironment.DEV,
    internal: true,
  },
  [ EcEnvironments.LOCAL_EC_ANGULAR.name ]: {
    siteId: 22,
    environment: MatomoEnvironment.DEV,
    internal: true,
  },
  [ EcEnvironments.LOCAL_EC_REACT.name ]: {
    siteId: 22,
    environment: MatomoEnvironment.DEV,
    internal: true,
  },
  [ EcEnvironments.DEV.name ]: {
    siteId: 21,
    environment: MatomoEnvironment.DEV,
    internal: false,
  },
  [ EcEnvironments.INTERNAL_DEV.name ]: {
    siteId: 22,
    environment: MatomoEnvironment.DEV,
    internal: true,
  },
  [ EcEnvironments.ALPHA.name ]: {
    siteId: 31,
    environment: MatomoEnvironment.ALPHA,
    internal: false,
  },
  [ EcEnvironments.INTERNAL_ALPHA.name ]: {
    siteId: 30,
    environment: MatomoEnvironment.ALPHA,
    internal: true,
  },
  [ EcEnvironments.BETA.name ]: {
    siteId: 23,
    environment: MatomoEnvironment.PROD,
    internal: false,
  },
  [ EcEnvironments.INTERNAL_BETA.name ]: {
    siteId: 24,
    environment: MatomoEnvironment.PROD,
    internal: true,
  },
  [ EcEnvironments.PRODUCTION.name ]: {
    siteId: 26,
    environment: MatomoEnvironment.PROD,
    internal: false,
  },
  [ EcEnvironments.INTERNAL_PRODUCTION.name ]: {
    siteId: 25,
    environment: MatomoEnvironment.PROD,
    internal: true,
  },
};
